export default {
  cscName: 'CSC 名称',
  orderType: '订单类型',
  orderNo: '订单号',
  cartonNo: '箱号',
  platformOrderNo: '平台订单号',
  expressTrackingNo: '运单号',
  sku: 'SKU',
  pe: 'PE',
  actualOrderQty: '实际发货数量',
  rfidScanQty: 'RFID 扫描数量',
  gap: '差异',
  exceptionReason: '异常原因',
  shipFrom: 'Ship From',
  shipFromName: 'Ship From 名称',
  shipTo: 'Ship To',
  shipToName: 'Ship To 名称',
  orderConfirmedTime: '订单确认时间',
  orderScheduledTime: '库存预定成功时间',
  orderPackedTime: '仓库打包时间',
  orderCreateTime: '订单创建时间',
  giTime: '仓库出库时间',
  orderUpc: 'Order UPC',
  rfidEpc: 'RFID EPC',
  epcDecodedUpc: 'EPC解码UPC',
  scanTime: '扫描时间'
}
